import { render, staticRenderFns } from "./SportKind.vue?vue&type=template&id=1536c3e0"
import script from "./SportKind.vue?vue&type=script&lang=js"
export * from "./SportKind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports